<div class="activities-container">
  <div class="activities-wrapper">
    <div class="activities-header">
      <div class="activities-title-row">
        <h3 class="activities-title">Activités</h3>

        <div class="report-actions">
          <button
            *ngIf="hasAccess(['SU', 'RA'])"
            class="report-button report-pdf"
            title="Télécharger le rapport PTA (PDF)"
            aria-label="Télécharger le rapport PTA au format PDF"
            (click)="telechargerRapportPta()"
          >
            <mat-icon>picture_as_pdf</mat-icon>
          </button>

          <button
            *ngIf="hasAccess(['SU', 'RA'])"
            class="report-button report-xlsx"
            title="Télécharger le rapport PTA (XLSX)"
            aria-label="Télécharger le rapport PTA au format XLSX"
            (click)="telechargerRapportPtaXlsx()"
          >
            <mat-icon>table_chart</mat-icon>
          </button>
        </div>
      </div>

      <h4 class="activities-subtitle">Gestion de vos activités</h4>
    </div>

    <div class="activities-content">
      <app-ongletlayout
        storageId="activities"
        [ongletLinks]="tableLinkForActivities"
        [title]="''"
        (onClickMenu)="onClickMenu()"
      >
        <div>
          <router-outlet></router-outlet>
        </div>
      </app-ongletlayout>
    </div>
  </div>
</div>